function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = ({
  size = 24,
  title,
  desc,
  titleId,
  descId,
  tabIndex = -1,
  focusable = false,
  role = 'img',
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": ariaHidden,
    fill: "currentcolor",
    role: role,
    tabIndex: tabIndex,
    focusable: focusable
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("path", {
    d: "M12 8c1.966 0 3.904.396 5.812 1.188 1.909.791 3.604 1.979 5.088 3.562.2.2.3.433.3.7 0 .267-.1.5-.3.7l-2.3 2.25a.975.975 0 01-1.3.1l-2.9-2.2a.993.993 0 01-.3-.35.992.992 0 01-.1-.45v-2.85a15.13 15.13 0 00-1.95-.475A11.868 11.868 0 0012 10c-.7 0-1.383.058-2.05.175-.667.117-1.317.275-1.95.475v2.85a.992.992 0 01-.1.45.992.992 0 01-.3.35l-2.9 2.2a.975.975 0 01-1.3-.1l-2.3-2.25a.96.96 0 01-.3-.7c0-.267.1-.5.3-.7 1.466-1.583 3.158-2.77 5.075-3.563C8.09 8.396 10.033 8 12 8z"
  }));
};
const SvgCallEnd = styled(BaseComponent).withConfig({
  displayName: "CallEnd__SvgCallEnd",
  componentId: "sc-10mu6yf-0"
})(["outline:none;"]);
SvgCallEnd.isIcon = true;
export default SvgCallEnd;